import { SEEK_FACEBOOK_URL, SEEK_TWITTER_URL } from '@seek/shared-constants';
import {
  Box,
  ButtonIcon,
  IconSocialFacebook,
  IconSocialX,
  Inline,
} from 'braid-design-system';
import type React from 'react';

import { Link } from 'src/components';
import { TRACKING_CODES } from 'src/shared/constant';
import type { Site } from 'src/shared/types';

interface Props {
  site: Site;
}

const SocialMediaBox: React.FC<Props> = ({ site }) => (
  <Box>
    <Inline space="small">
      <Link
        id="social-link-facebook"
        target="_blank"
        href={SEEK_FACEBOOK_URL[site]}
        tracking={TRACKING_CODES.content_element_pressed}
        trackingProps={{
          elementDesign: 'link',
          elementText: 'fb.me/SEEK',
        }}
      >
        <ButtonIcon
          id="facebook-link"
          label="Visit us on Facebook"
          icon={<IconSocialFacebook />}
        />
      </Link>
      <Link
        target="_blank"
        href={SEEK_TWITTER_URL[site]}
        tracking={TRACKING_CODES.content_element_pressed}
        trackingProps={{
          elementDesign: 'link',
          elementText: '@seekjobs',
        }}
      >
        <ButtonIcon id="x-link" label="Visit us on X" icon={<IconSocialX />} />
      </Link>
    </Inline>
  </Box>
);

export default SocialMediaBox;
